import i18next from "i18next";

import ru from './locales/ru.json';
import en from './locales/en.json';
import ua from './locales/ua.json';

import { initReactI18next } from "react-i18next";

export const defaultLang = localStorage.getItem('i18nextLng') || "en";

export const resources = {
  en: { translation: en },
  ru: { translation: ru },
  ua: { translation: ua }
} as const;

i18next
  .use(initReactI18next)
  .init({
    lng: defaultLang,
    fallbackLng: 'en',
    debug: true,
    resources: resources,
  });
